interface LDUser {
  key: string
  name?: string
  email?: string
  anonymous?: boolean
  custom?: Record<string, any>
}

export interface LaunchDarklyConfig {
  clientSideID: string
  context?: LDUser
  options?: {
    baseUrl?: string
    eventsUrl?: string
    streamUrl?: string
    streaming?: boolean
    useReport?: boolean
    debug?: boolean
    privateAttributeNames?: string[]
    allAttributesPrivate?: boolean
    [key: string]: any
  }
}

/**
 * Create LaunchDarkly configuration
 */
export function createLaunchDarklyConfig(config: LaunchDarklyConfig): LaunchDarklyConfig {
  const defaultOptions = {
    streaming: true,
    debug: import.meta.env.DEV || false,
    privateAttributeNames: ['email', 'username'], // Protect sensitive user data
    allAttributesPrivate: false,
  }

  return {
    ...config,
    options: {
      ...defaultOptions,
      ...config.options
    }
  }
}

/**
 * Create anonymous user for LaunchDarkly when no user is authenticated
 */
export function createAnonymousUser(): LDUser {
  // Generate a consistent anonymous key for the session
  let anonymousKey = sessionStorage.getItem('ld-anonymous-key')
  if (!anonymousKey) {
    anonymousKey = 'anonymous-' + Math.random().toString(36).substr(2, 9)
    sessionStorage.setItem('ld-anonymous-key', anonymousKey)
  }

  return {
    key: anonymousKey,
    anonymous: true,
    custom: {
      context: 'unauthenticated'
    }
  }
}

/**
 * Create user context for LaunchDarkly from authenticated user
 */
export function createUserContext(user: any): LDUser {
  return {
    key: user.email
  }
}
